import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { laborPerformanceService } from '../api/laborPerformance.service';
import { LABOR_PERFORMANCE_KEYS } from './queryKeys';

export function useLaborPerformanceSummary(periodStart: string, periodEnd: string) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: LABOR_PERFORMANCE_KEYS.summary(activeOrganizationId ?? '', periodStart, periodEnd),
    queryFn: ({ signal }) => laborPerformanceService.getSummary({ periodStart, periodEnd }, signal),
    staleTime: 5 * 60 * 1000,
    enabled: !!activeOrganizationId && !!periodStart && !!periodEnd,
  });
}
